export const profile = {
    fullName: "Hoàng Dân An",
    englishName: "An Hoang",
    nickname: "Beo",
    phone: "*****",
};
